// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reporting {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

.headerContainer {
  height: 10%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 35px;
}

.headerButton {
  background: #ffffff;
  color: #004481;
  border-radius: 25px;
  padding: 5px;
  font-size: 12px;
  font-weight: 600;
  border: 2px solid #004481;
  height: 40px;
  width: auto;
  top: 10px;
  right: 20px;
}

.headerButton:hover {
  background: #f0f5ff;
  color: #003366;
  border-color: #003366;
}

.contentContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding: 20px 35px;
}

.antCard {
  width: 100%;
  height: 100%;
  border-radius: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.2),
    0 8px 16px rgba(0, 0, 0, 0.2);
}
.ant-card .ant-card-head {
  height: 60px;
  background-color: #2c5778;
  border-radius: 25px 25px 0 0;
  border-bottom: none;
}

.antTabs {
  display: flex;
  justify-content: center;
}

.ant-tabs .ant-tabs-nav {
  flex: 1;
  justify-content: center;
}
.ant-tabs .ant-tabs-tab {
  flex: 1;
  text-align: center;
  padding: 0;
  font-weight: 600;
  font-size: 15px;
  
}
.nested-tabs .ant-tabs-tab {
  color: #004481;
  padding: 0;
  font-weight: 600;
  font-size: 15px;
}
.nested-tabs .ant-tabs-tab-active {
  color: #ffffff;
}
.ant-tabs .ant-tabs-tab:hover {
  color: #000000;
}
.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
  display: grid;
}
.ant-tabs-nav-operations {
  display: none !important;
}
@media (max-width: 768px) {
  .headerContainer {
    padding: 0 10px;
    justify-content: flex-end;
  }
  .headerButton {
    font-size: 10px;
    padding: 5px 10px;
    margin: 5px;
    height: 35px;
    right: 0;
  }
  .contentContainer {
    padding: 15px 20px;
  }
  .antCard {
    margin: 10px;
  }
}
@media (max-width: 480px) {
  .headerButton {
    font-size: 12px;
    padding: 5px;
    right: 0;
  }
  .contentContainer {
    padding: 10px 15px;
  }
  .antCard {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Supplier/reporting/reporting.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;iCAC+B;AACjC;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;;AAEjB;AACA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;IACZ,QAAQ;EACV;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".reporting {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n}\n\n.headerContainer {\n  height: 10%;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 35px;\n}\n\n.headerButton {\n  background: #ffffff;\n  color: #004481;\n  border-radius: 25px;\n  padding: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 2px solid #004481;\n  height: 40px;\n  width: auto;\n  top: 10px;\n  right: 20px;\n}\n\n.headerButton:hover {\n  background: #f0f5ff;\n  color: #003366;\n  border-color: #003366;\n}\n\n.contentContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  padding: 20px 35px;\n}\n\n.antCard {\n  width: 100%;\n  height: 100%;\n  border-radius: 25px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.2),\n    0 8px 16px rgba(0, 0, 0, 0.2);\n}\n.ant-card .ant-card-head {\n  height: 60px;\n  background-color: #2c5778;\n  border-radius: 25px 25px 0 0;\n  border-bottom: none;\n}\n\n.antTabs {\n  display: flex;\n  justify-content: center;\n}\n\n.ant-tabs .ant-tabs-nav {\n  flex: 1;\n  justify-content: center;\n}\n.ant-tabs .ant-tabs-tab {\n  flex: 1;\n  text-align: center;\n  padding: 0;\n  font-weight: 600;\n  font-size: 15px;\n  \n}\n.nested-tabs .ant-tabs-tab {\n  color: #004481;\n  padding: 0;\n  font-weight: 600;\n  font-size: 15px;\n}\n.nested-tabs .ant-tabs-tab-active {\n  color: #ffffff;\n}\n.ant-tabs .ant-tabs-tab:hover {\n  color: #000000;\n}\n.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {\n  display: grid;\n}\n.ant-tabs-nav-operations {\n  display: none !important;\n}\n@media (max-width: 768px) {\n  .headerContainer {\n    padding: 0 10px;\n    justify-content: flex-end;\n  }\n  .headerButton {\n    font-size: 10px;\n    padding: 5px 10px;\n    margin: 5px;\n    height: 35px;\n    right: 0;\n  }\n  .contentContainer {\n    padding: 15px 20px;\n  }\n  .antCard {\n    margin: 10px;\n  }\n}\n@media (max-width: 480px) {\n  .headerButton {\n    font-size: 12px;\n    padding: 5px;\n    right: 0;\n  }\n  .contentContainer {\n    padding: 10px 15px;\n  }\n  .antCard {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
